import React, { useState } from 'react';
import {
  Paper,
  Typography,
  MenuItem,
  Select,
  TextField,
  Button,
} from '@mui/material';

import { trpc } from '../../api/trpc';
import { Row } from '../../atoms/row';
import {
  FlexibilityCommandBattery,
  FlexibilityCommandPv,
  FlexibilityCommandType,
} from '../../../../core/src/shared/enums';

type Props = {
  type: FlexibilityCommandType;
};

export const FlexibilityTest = ({ type }: Props) => {
  const [battery, setBattery] = useState(FlexibilityCommandBattery.Default);
  const [pv, setPv] = useState(FlexibilityCommandPv.Unrestricted);
  const [ttl, setTtl] = useState(600);
  const [targetSoc, setTargetSoc] = useState(0.8);

  const { mutate } = trpc.flexibility.commandTest.useMutation();

  const submit = () => {
    mutate({
      type,
      payload: {
        battery,
        pv,
        target_soc_percentage: targetSoc,
        ttl_seconds: ttl,
      },
    });
  };

  return (
    <Paper>
      <Typography variant="h3" sx={{ mb: 2 }}>
        Command Test
      </Typography>

      <Row gap={1}>
        <Select
          label="Battery"
          value={battery}
          onChange={(e) => {
            setBattery(e.target.value as FlexibilityCommandBattery);
          }}
        >
          {Object.values(FlexibilityCommandBattery).map((command) => (
            <MenuItem key={command} value={command}>
              {command}
            </MenuItem>
          ))}
        </Select>

        <Select
          label="PV"
          value={pv}
          onChange={(e) => {
            setPv(e.target.value as FlexibilityCommandPv);
          }}
        >
          {Object.values(FlexibilityCommandPv).map((command) => (
            <MenuItem key={command} value={command}>
              {command}
            </MenuItem>
          ))}
        </Select>

        <TextField
          value={targetSoc}
          onChange={(e) => setTargetSoc(Number(e.target.value))}
          label="Target SOC"
          size="small"
        />

        <TextField
          value={ttl}
          onChange={(e) => setTtl(Number(e.target.value))}
          label="TTL in seconds"
          size="small"
        />

        <Button variant="contained" size="small" onClick={submit}>
          Odeslat
        </Button>
      </Row>
    </Paper>
  );
};
